import { useEffect } from 'react';
import { baseFolder } from '../constants';
import { getImagesFolder } from '../utilities/getImagesFolder';

// Swaps the favicon to the env-specific asset shipped in `public/favicons/<folder>/favicon.ico`.
// The folder is derived from `window.location.hostname` (see `getImagesFolder`) so no backend
// call is required — acorn's cloud-function backend does not proxy the SPA config endpoint.
export const useFavicon = (): void => {
  useEffect(() => {
    const folder = getImagesFolder();
    const href = `${baseFolder}/favicons/${folder}/favicon.ico`;
    const faviconLinks = document.querySelectorAll<HTMLLinkElement>("link[rel*='icon']");

    if (faviconLinks.length === 0) {
      const link = document.createElement('link');
      link.rel = 'shortcut icon';
      link.href = href;
      document.head.appendChild(link);
      return;
    }

    faviconLinks.forEach((link) => {
      link.href = href;
    });
  }, []);
};
